import { useEffect } from 'react';

import ReactGA from 'react-ga4';

import { useScrollToLocation } from '@/hooks/useScrollToLocation';

// Layout components
import { Header } from './components/Header';
import { Footer } from './components/Footer';

// Page section components
import { Main } from './components/Main';
import { Story } from './components/Story';
import { Demo } from './components/Demo';
import { Benefits } from './components/Benefits';
import { Features } from './components/Features';
import { Cases } from './components/Cases';

export default function App() {
  useEffect(() => {
    ReactGA.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID);
    ReactGA.send({ hitType: 'pageview', page: globalThis.location.pathname });
  }, []);

  useScrollToLocation();

  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden bg-secondary-secondary-05">
      {/* Skip to main content link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded-md focus:bg-primary-primary-50 focus:px-4 focus:py-2 focus:text-white focus:outline-none"
      >
        Skip to main content
      </a>

      {/* Fixed header */}
      <Header />

      {/* Main content sections */}
      <main id="main-content" className="flex flex-col" role="main">
        <Main />
        <div id="Story">
          <Story />
        </div>
        <div id="Demo">
          <Demo />
        </div>
        <div id="Benefits">
          <Benefits />
        </div>
        <div id="Features">
          <Features />
        </div>
        <div id="Cases">
          <Cases />
        </div>
      </main>

      {/* Footer section */}
      <Footer />
    </div>
  );
}
